import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookie from "vue-cookie";
import "@/element-ui"; // api: https://github.com/ElemeFE/element
import "@/element-ui-theme";
import "@/assets/scss/index.scss";
import httpRequest from "@/utils/httpRequest"; // api: https://github.com/axios/axios
import { isAuth } from "@/utils";
import cloneDeep from "lodash/cloneDeep";
import Clipboard from "clipboard"; // 点击复制

Vue.use(VueCookie);

Vue.config.productionTip = false;

// 挂载全局
Vue.prototype.$http = httpRequest; // ajax请求方法
Vue.prototype.isAuth = isAuth; // 权限方法
Vue.prototype.$tableHeight =
  document.documentElement.clientHeight - 50 - 55 - 50 - 18 - 15 - 15 - 2; // 列表页表格高度
Vue.prototype.Clipboard = Clipboard;

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG["storeState"] = cloneDeep(store.state);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
